namespace $ {
	$mol_report_bugsnag = '18acf016ed2a2a4cc4445daa9dd2dd3c'
}
